var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNounIdea3913680(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "noun-idea-3913680",
    xmlns: "http://www.w3.org/2000/svg",
    width: 100.876,
    height: 106.667,
    viewBox: "0 0 100.876 106.667",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_406",
    "data-name": "Path 406",
    d: "M239.112,122.61c-19.273,0-35.13,15.07-35.132,33.766v.006a32.956,32.956,0,0,0,9.528,22.691,3.657,3.657,0,0,0,.718,1.14l9.528,10.143h0a3.649,3.649,0,0,0,2.659,1.146h25.4a3.65,3.65,0,0,0,2.659-1.146L264,180.213a3.643,3.643,0,0,0,.7-1.1,32.959,32.959,0,0,0,9.545-22.736h0v-.006c0-18.7-15.859-33.768-35.132-33.766Zm0,7.3c15.5,0,27.833,11.9,27.835,26.468a25.8,25.8,0,0,1-8.146,18.7h0a3.708,3.708,0,0,0-.345.384l-8.218,8.75H227.995l-8.158-8.684a3.715,3.715,0,0,0-.4-.45,25.818,25.818,0,0,1-8.158-18.7c0-14.57,12.337-26.466,27.835-26.464Z",
    transform: "translate(-188.676 -107.117)",
    fill: "#0f8a45"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_407",
    "data-name": "Path 407",
    d: "M355.851,171.989a3.65,3.65,0,0,0-.752,7.231,16.4,16.4,0,0,1,8,4.178,15.259,15.259,0,0,1,3.427,4.847h0a3.649,3.649,0,1,0,6.672-2.955,22.558,22.558,0,0,0-5.055-7.171,23.671,23.671,0,0,0-11.573-6.041,3.609,3.609,0,0,0-.724-.087Z",
    transform: "translate(-301.194 -144.615)",
    fill: "#0f8a45"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_408",
    "data-name": "Path 408",
    d: "M285.7,378.62a3.65,3.65,0,0,0-3.471,4.781l4.052,12.434a3.652,3.652,0,0,0,3.471,2.517h17.3a3.653,3.653,0,0,0,3.465-2.517L314.57,383.4h0a3.649,3.649,0,0,0-3.47-4.781Zm5.027,7.3h15.346l-1.678,5.137h-12l-1.672-5.137Z",
    transform: "translate(-247.961 -301.531)",
    fill: "#0f8a45"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_409",
    "data-name": "Path 409",
    d: "M338.432,58.218a3.649,3.649,0,0,0-3.591,3.7v4.754a3.649,3.649,0,1,0,7.3,0V61.918a3.65,3.65,0,0,0-3.706-3.7Z",
    transform: "translate(-288.051 -58.217)",
    fill: "#0f8a45"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_410",
    "data-name": "Path 410",
    d: "M201.051,115.14a3.649,3.649,0,0,0-2.544,6.266l3.361,3.361a3.65,3.65,0,1,0,5.159-5.164l-3.355-3.355h0a3.648,3.648,0,0,0-2.621-1.107Z",
    transform: "translate(-183.68 -101.444)",
    fill: "#0f8a45"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_411",
    "data-name": "Path 411",
    d: "M465.081,115.155a3.655,3.655,0,0,0-2.511,1.1l-3.361,3.355h0a3.651,3.651,0,0,0,5.163,5.164l3.355-3.361h0a3.65,3.65,0,0,0-2.648-6.261Z",
    transform: "translate(-381.685 -101.455)",
    fill: "#0f8a45"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_412",
    "data-name": "Path 412",
    d: "M144.1,252.557a3.65,3.65,0,1,0,0,7.3h4.748a3.65,3.65,0,1,0,0-7.3Z",
    transform: "translate(-140.372 -205.798)",
    fill: "#0f8a45"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_413",
    "data-name": "Path 413",
    d: "M512.624,252.557a3.65,3.65,0,1,0,0,7.3h4.748a3.65,3.65,0,1,0,0-7.3Z",
    transform: "translate(-420.227 -205.798)",
    fill: "#0f8a45"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_414",
    "data-name": "Path 414",
    d: "M321.314,471.217a3.649,3.649,0,1,0,0,7.3h8.141a3.649,3.649,0,1,0,0-7.3h-8.142Z",
    transform: "translate(-274.946 -371.849)",
    fill: "#0f8a45"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNounIdea3913680);
export default __webpack_public_path__ + "static/media/noun-idea-3913680.a2e564050e28f50e3e068024c92de218.svg";
export { ForwardRef as ReactComponent };